import { Observable } from 'rxjs';
import { Role } from '@cation/core/auth/role.enum';

/**
 * Navigation item interface for sidebar navigation
 */
export interface NavigationItem {
  id: string;
  label: string;
  translationKey: string;
  icon: string;
  iconType: 'bootstrap' | 'material' | 'fontawesome';
  route: string;
  roles: Role[];
  badge?: Observable<number>;
  children?: NavigationItem[];
}

/**
 * Team Admin sub-navigation items
 * Shown in sidebar when user is on /admin routes
 */
export const TEAM_ADMIN_NAV_ITEMS: NavigationItem[] = [
  {
    id: 'manage-users',
    label: 'Manage Users',
    translationKey: 'NAVBAR.MANAGE_USERS_LINK',
    icon: 'person-gear',
    iconType: 'bootstrap',
    route: '/admin/manage/user',
    roles: [Role.ADMIN]
  },
  {
    id: 'manage-teams',
    label: 'Manage Teams',
    translationKey: 'NAVBAR.MANAGE_TEAMS_LINK',
    icon: 'people',
    iconType: 'bootstrap',
    route: '/admin/manage/team',
    roles: [Role.ADMIN]
  },
  {
    id: 'agents-audit',
    label: 'Agents Audit',
    translationKey: 'NAVBAR.AGENTS_AUDIT_LINK',
    icon: 'clipboard-data',
    iconType: 'bootstrap',
    route: '/admin/agents/audit',
    roles: [Role.ADMIN]
  },
  {
    id: 'review-users',
    label: 'Review Users',
    translationKey: 'NAVBAR.REVIEW_USERS_LINK',
    icon: 'person-check',
    iconType: 'bootstrap',
    route: '/admin/review/user',
    roles: [Role.ADMIN]
  },
  {
    id: 'teams-statistics',
    label: 'Statistics',
    translationKey: 'NAVBAR.TEAMS_STATISTICS_LINK',
    icon: 'bar-chart',
    iconType: 'bootstrap',
    route: '/admin/teams/statistics',
    roles: [Role.ADMIN]
  },
  {
    id: 'send-mail',
    label: 'Send Mail',
    translationKey: 'NAVBAR.SEND_MAIL',
    icon: 'envelope',
    iconType: 'bootstrap',
    route: '/admin/manage/send-mail',
    roles: [Role.ADMIN]
  }
];

/**
 * Gamification sub-navigation items
 * Shown in sidebar when user is on /admin/gamification routes
 */
export const GAMIFICATION_NAV_ITEMS: NavigationItem[] = [
  {
    id: 'gamification-settings',
    label: 'Settings',
    translationKey: 'NAVBAR.GAMIFICATION_SETTINGS_LINK',
    icon: 'gear',
    iconType: 'bootstrap',
    route: '/admin/gamification/settings',
    roles: [Role.ADMIN]
  },
  {
    id: 'gamification-achievements',
    label: 'Achievements',
    translationKey: 'NAVBAR.GAMIFICATION_ACHIEVEMENTS_LINK',
    icon: 'award',
    iconType: 'bootstrap',
    route: '/admin/gamification/achievements',
    roles: [Role.ADMIN]
  },
  {
    id: 'master-league',
    label: 'Master League',
    translationKey: 'NAVBAR.GAMIFICATION_MASTER_LEAGUE_LINK',
    icon: 'trophy',
    iconType: 'bootstrap',
    route: '/admin/gamification/master-league',
    roles: [Role.ADMIN]
  }
];

/**
 * Main navigation configuration for the application sidebar
 * Items are filtered based on user roles at runtime
 */
export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    id: 'profile',
    label: 'Profile',
    translationKey: 'NAVBAR.PROFILE_LINK',
    icon: 'person',
    iconType: 'material',
    route: '/profile',
    roles: [Role.ADMIN, Role.TEAM_LEAD, Role.AGENT, Role.CONTENT_ADMIN, Role.REPORTS_ADMIN]
  }
];
